import * as FileSaver from "file-saver";
import * as Papa from "papaparse";
import { useIntl } from "react-intl";

type Props = {};

const DownloadFile = (props: Props) => {
  const downloadCSVFile = () => {
    const csv = Papa.unparse(
      [
        {
          first_name: "",
          last_name: "",
          email: "",
          gender: "",
          phone: "",
          preferred_staff_gender: "",
          // client_info: "",
          birth_date: "",
          additional_phone: "",
          address: "",
          // display_all_booking: "",
        },
      ],
      { header: true }
    );
    const blob = new Blob([csv], { type: "text/csv;charset=utf-8" });
    const fileName = "clients.csv";
    FileSaver.saveAs(blob, fileName);
  };
  const intl = useIntl();

  return (
    <div
      onClick={downloadCSVFile}
      className="bg-white cursor-pointer mb-2 hover:bg-color-gray-light rounded-lg w-full text-center grid p-8 gap-4 items-center justify-center"
    >
      <div className="flex items-center justify-center w-full text-center">
        <span className="bg-color-primary px-2 py-[0.2rem] rounded-full text-white text-xs text-center">
          1
        </span>
      </div>
      <div className="flex flex-col w-full justify-center items-center gap-4">
        <span className="text-[#020418] text-sm font-semibold">
          {intl.formatMessage({
            id: "downloadFileTitle",
          })}
        </span>
        <span className="text-[#75757E] text-sm font-semibold">
          {intl.formatMessage({
            id: "downloadFileSubTitle",
          })}
        </span>
      </div>
      <div className="flex items-center justify-center">
        <svg
          width="65"
          height="64"
          viewBox="0 0 65 64"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M58.1708 64H16.4308C13.3308 64 10.8008 61.48 10.8008 58.37V49.39C10.8008 48.85 11.2308 48.42 11.7708 48.42C12.3108 48.42 12.7408 48.85 12.7408 49.39V58.37C12.7408 60.4 14.4008 62.06 16.4308 62.06H58.1608C60.1908 62.06 61.8508 60.4 61.8508 58.37V16.4L48.9908 1.94H16.4308C14.4008 1.94 12.7408 3.59 12.7408 5.63V21.5C12.7408 22.04 12.3108 22.47 11.7708 22.47C11.2308 22.47 10.8008 22.04 10.8008 21.5V5.63C10.8008 2.53 13.3308 0 16.4308 0H49.4208C49.7008 0 49.9608 0.12 50.1408 0.33L63.5408 15.39C63.7008 15.57 63.7908 15.8 63.7908 16.03V58.37C63.7908 61.48 61.2708 64 58.1708 64Z"
            fill="#9999A7"
          />
          <path
            d="M62.8212 17H49.4212C48.8812 17 48.4512 16.57 48.4512 16.03V0.97C48.4512 0.43 48.8812 0 49.4212 0C49.9612 0 50.3912 0.43 50.3912 0.97V15.06H62.8212C63.3612 15.06 63.7912 15.49 63.7912 16.03C63.7912 16.57 63.3612 17 62.8212 17Z"
            fill="#9999A7"
          />
          <path
            d="M19.4511 44.56C16.9311 44.56 14.8711 42.5099 14.8711 39.9799C14.8711 39.4399 15.3011 39.0099 15.8411 39.0099C16.3811 39.0099 16.8111 39.4399 16.8111 39.9799C16.8111 41.4299 17.9911 42.6199 19.4511 42.6199C20.1511 42.6199 20.8111 42.3499 21.3111 41.8499C21.8111 41.3499 22.0811 40.69 22.0811 39.99C22.0811 38.57 20.9611 37.3799 19.5711 37.3499C17.0711 37.3499 15.0211 35.3 15.0211 32.77C15.0211 31.55 15.5011 30.4 16.3611 29.54C17.2211 28.68 18.3711 28.2 19.5911 28.2C20.8111 28.2 21.9611 28.68 22.8211 29.54C23.6811 30.4 24.1611 31.5499 24.1611 32.7799C24.1611 33.3199 23.7311 33.75 23.1911 33.75C22.6511 33.75 22.2211 33.3199 22.2211 32.7799C22.2211 32.0799 21.9511 31.41 21.4511 30.92C20.9511 30.42 20.2911 30.15 19.5911 30.15C18.8911 30.15 18.2211 30.42 17.7311 30.92C17.2311 31.42 16.9611 32.0799 16.9611 32.7799C16.9611 34.2299 18.1411 35.4199 19.5911 35.4199C22.0411 35.4699 24.0211 37.53 24.0111 40C24.0111 41.22 23.5311 42.37 22.6711 43.2299C21.8211 44.08 20.6711 44.56 19.4511 44.56Z"
            fill="#9999A7"
          />
          <path
            d="M32.3515 43.6399C32.3515 43.6399 32.3415 43.6399 32.3315 43.6399C31.9315 43.6299 31.5815 43.3899 31.4415 43.0099L26.6515 30.4299C26.4615 29.9299 26.7115 29.3699 27.2115 29.1799C27.7115 28.9899 28.2715 29.2399 28.4615 29.7399L32.3815 40.0499L36.6815 29.7199C36.8915 29.2299 37.4515 28.9899 37.9515 29.1999C38.4415 29.4099 38.6815 29.9699 38.4715 30.4699L33.2315 43.0499C33.1015 43.3999 32.7415 43.6399 32.3515 43.6399Z"
            fill="#9999A7"
          />
          <path
            d="M6.85094 44.39C3.74094 44.39 1.21094 41.86 1.21094 38.75V34C1.21094 30.89 3.74094 28.36 6.85094 28.36C8.63094 28.36 10.3209 29.21 11.3809 30.64L11.5609 30.88C11.8809 31.31 11.7909 31.92 11.3609 32.24C10.9309 32.56 10.3209 32.47 10.0009 32.04L9.82094 31.8C9.13094 30.87 8.02094 30.31 6.85094 30.31C4.81094 30.31 3.15094 31.97 3.15094 34.01V38.77C3.15094 40.81 4.81094 42.47 6.85094 42.47C8.02094 42.47 9.13094 41.91 9.82094 40.98L10.0009 40.74C10.3209 40.31 10.9309 40.22 11.3609 40.54C11.7909 40.86 11.8809 41.47 11.5609 41.9L11.3809 42.14C10.3209 43.54 8.62094 44.39 6.85094 44.39Z"
            fill="#9999A7"
          />
        </svg>
      </div>
      <div className="flex items-center justify-center gap-[10px] py-2 px-6 border-[1px] border-solid w-fit mx-auto rounded-lg border-[#75757E]">
        <span className="text-[#75757E] text-sm">
          {intl.formatMessage({
            id: "download",
          })}
        </span>
      </div>
    </div>
  );
};

export default DownloadFile;
